import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import {provideRouter, withEnabledBlockingInitialNavigation, withHashLocation} from '@angular/router';

import { routes } from './app.routes';
import {provideCacheableAnimationLoader, provideLottieOptions} from "ngx-lottie";
import player from 'lottie-web';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {provideHttpClient} from "@angular/common/http";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideLottieOptions({ player: () => player }),
    provideCacheableAnimationLoader(),
    provideRouter(routes,
      withHashLocation(),
      withEnabledBlockingInitialNavigation()),
    provideAnimationsAsync(),
    provideHttpClient()
  ]
};
